/**
 * A basic utility which returns if the scroll position is at top, middle or bottom.
 * This is isolated to make the show-borders-after-scroll feature testable.
 */
export type TScrollPosName = 'top' | 'middle' | 'bottom';
export type TGetScrollPositionName = (
  y: number,
  el: HTMLElement | null
) => TScrollPosName;

export const getScrollPositionName: TGetScrollPositionName = (y, el) => {
  const isTop = y === 0;
  const isBottom = el ? y + el.offsetHeight >= el.scrollHeight : false;
  return isTop ? 'top' : isBottom ? 'bottom' : 'middle';
};
